import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop reordering. Attach to a container; mark each child with
// data-sortable-id and a drag handle with data-sortable-handle. On drop it
// PATCHes the new id order to data-sortable-url-value.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-sortable-handle]",
      animation: 150,
      onEnd: () => this.save()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async save() {
    const ids = Array.from(this.element.querySelectorAll("[data-sortable-id]"))
      .map((el) => el.dataset.sortableId)
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ ids })
    })
  }
}
